<template>
  <div class="header">
    <!--WRAPPER sur toute la zone d'interaction -->
    <div
      class="cart-wrapper"
      ref="cartRef"
      @mouseenter="showCartPopup = true"
      @mouseleave="showCartPopup = false"
    >
      <div class="cart-icon">
        <i class="fas fa-shopping-cart"></i>
        <span class="cart-count">{{ cart.length }}</span>
      </div>
    </div>

    <!-- POPUP en dehors du flux -->
    <teleport to="body">
      <div
        v-if="showCartPopup && cart.length > 0"
        class="cart-popup-teleport"
        :style="popupPosition"
        @mouseenter="showCartPopup = true"
        @mouseleave="showCartPopup = false"
      >
      <!-- 🛒 Titre avec nombre d’articles -->
<div class="cart-summary-header">
  <h3>Mon panier ({{ cart.length }} article<span v-if="cart.length > 1">s</span>)</h3>
</div>

<!-- Liste des articles -->
<div class="cart-items">
  <div v-for="(item, index) in cart" :key="index" class="cart-item">
    <img :src="item.image" alt="Image produit" class="product-image" />
    <div class="item-details">
      <h4 class="item-name">{{ item.name }}</h4>
      <p class="item-quantity">Quantité : {{ item.quantity }}</p>
      <p class="item-price">Prix : {{ (item.price * item.quantity).toFixed(2) }} MAD</p>
    </div>
  </div>
</div>

<!--  Total TTC -->
<div class="cart-total">
  <p>Total TTC : <span>{{ totalPrice.toFixed(2) }} MAD</span></p>
</div>

<!-- Boutons d'action -->
<div class="cart-actions">
  <button @click="goToCart" class="btn-view-cart">voir panier</button>
  <button @click="goToShipping" class="btn-checkout">Commander</button>
</div>

      </div>
    </teleport>
  </div>
</template>


<script>
import { store } from "@/Store";

export default {
  name: "HeaderI",
 data() {
  return {
    showCartPopup: false,
    popupTop: 0,
    popupRight: 0,
  };
},
computed: {
  cart() {
    return store.cart;
  },
  totalPrice() {
    return this.cart.reduce((total, item) => total + item.price * item.quantity, 0);
  },
  popupPosition() {
    return {
      position: "absolute",
      top: `${this.popupTop}px`,
      right: `${this.popupRight}px`,
      zIndex: 99999,
    };
  },
},
methods: {
  goToCart() {
    this.$router.push("/panier");
  },
  updatePopupPosition() {
    this.$nextTick(() => {
      const cartIcon = this.$el.querySelector(".cart-icon");
      if (cartIcon) {
        const rect = cartIcon.getBoundingClientRect();
        this.popupTop = rect.bottom + window.scrollY;
        this.popupRight = window.innerWidth - rect.right;
      }
    });

  },
  goToShipping() {
  this.$router.push("/shipping");
}

},
watch: {
  showCartPopup(val) {
    if (val) {
      this.updatePopupPosition();
    }
  },
}

};
</script>

<style scoped>
/* ====== MODE CLAIR PAR DÉFAUT ====== */
.cart-wrapper {
  position: relative;
  display: inline-block;
}

.cart-popup-teleport {
  width: 300px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 15px;
  z-index: 99999;
}

.header {
  position: relative;
  z-index: 9999;
}

.cart-icon {
  position: relative;
  cursor: pointer;
  font-size: 1.5rem;
  color: #333;
  position: relative;
  z-index: 9999;
}

.cart-count {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #e0240b;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 0.8rem;
}

/* Fenêtre popup du panier */
.cart-popup {
  position: fixed;
  top: 100%;
  right: 0;
  width: 300px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 15px;
  z-index: 99999;
}

.cart-items {
  max-height: 300px;
  overflow-y: auto;
}

.cart-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.product-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
}

.item-details {
  flex: 1;
}

.item-name {
  font-size: 0.9rem;
  margin: 0;
}

.item-quantity,
.item-price {
  font-size: 0.8rem;
  color: #555;
  margin: 2px 0;
}

.cart-total {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #ddd;
  text-align: right;
  font-size: 0.9rem;
}

.cart-total span {
  font-weight: bold;
  color: #2a9d8f;
}

.btn-view-cart {
  width: 100%;
  padding: 10px;
  background-color: #2a9d8f;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
  transition: background-color 0.3s;
}

.btn-view-cart:hover {
  background-color: #23877b;
}

.cart-summary-header h3 {
  margin: 0 0 10px;
  font-size: 1rem;
  font-weight: bold;
  color: #333;
}

.cart-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 15px;
}

.btn-checkout {
  width: 100%;
  padding: 10px;
  background-color: #e0240b;
  color: white;
  border: none;
  border-radius: 5px;
  margin-top: 10px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-checkout:hover {
  background-color: #c91d09;
}

/* Styles Responsives */
@media only screen and (max-width: 1024px) {
  .cart-count {
    top: -8px;
    right: -8px;
    padding: 2px 5px;
    font-size: 0.7rem;
  }
  .cart-popup {
    width: 250px;
    padding: 10px;
  }
  .cart-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  .product-image {
    width: 40px;
    height: 40px;
  }
  .item-name { font-size: 0.8rem; }
  .item-quantity, .item-price { font-size: 0.7rem; }
  .cart-total { font-size: 0.8rem; }
  .btn-view-cart { padding: 8px; font-size: 0.9rem; }
  .cart-icon {
    position: absolute;
    top: 45px;
    right: 10px;
    display: flex;
    gap: 10px;
  }
}

@media only screen and (max-width: 480px) {
  .cart-icon {
    position: absolute;
    top: 45px;
    right: 10px;
    display: flex;
    gap: 10px;
  }
  .cart-popup {
    width: 200px;
    padding: 8px;
  }
  .cart-item { gap: 3px; }
  .product-image { width: 30px; height: 30px; }
  .item-name { font-size: 0.7rem; }
  .item-quantity, .item-price { font-size: 0.6rem; }
  .cart-total { font-size: 0.7rem; }
  .btn-view-cart { padding: 6px; font-size: 0.8rem; }
}

/*====== MODE SOMBRE AUTOMATIQUE ====== */
@media (prefers-color-scheme: dark) {
  .cart-popup,
  .cart-popup-teleport {
    background-color: #1e1e1e;
    border-color: #333;
    box-shadow: 0 4px 12px rgba(255, 255, 255, 0.05);
  }

  .cart-summary-header h3 {
    color: #f1f1f1;
  }

  .cart-item {
    border-bottom: 1px solid #333;
  }

  .item-name {
    color: #f5f5f5;
  }

  .item-quantity,
  .item-price {
    color: #aaa;
  }

  .cart-total {
    border-top: 1px solid #333;
    color: #ddd;
  }

  .btn-view-cart {
    background-color: #078679;
  }
  .btn-view-cart:hover {
    background-color: #1ea395;
  }

  .btn-checkout {
    background-color: #c62828;
  }
  .btn-checkout:hover {
    background-color: #ef5350;
  }

  .cart-icon {
    color: #f5f5f5;
  }
}
</style>
